import React from "react"
import { Link } from "gatsby"


const Footer = () => {
  return (
    <footer>
    <div className="contained flex between wrap">
      <div className="mar-between">© 2021 • Michaela | Product Designer </div>
      <div className="mar-between">
        Connect with me via:
        <a href="mailto:myra.m.moore@gmail.com?subject=Hello" target="_blank" rel="noreferrer" title="email Michaela" className="foot-links">Email</a>•
        <a href="https://www.linkedin.com/in/michaela-moore-538b5251" target="_blank" rel="noreferrer" title="LinkedIn" className="foot-links">LinkedIn</a>
      </div>
    </div>
    </footer>
  );
}

export default Footer
